import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { questionSchema } from "./schema";
import { fetchQuestionData } from "./read";
import { useUpdateQuestion } from "../update/mutation";
import { useCreateQuestion } from "../create/mutation";

export const useQuestionForm = ({ questionId }) => {
  const form = useForm({
    resolver: zodResolver(questionSchema),
    defaultValues: {
      question: "",
      category: "",
    },
  });

  const updateQuestion = useUpdateQuestion();
  const createQuestion = useCreateQuestion();

  const handleCreate = async (context) => {
    const item = context.values;
    await createQuestion.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateQuestion.mutateAsync({ questionId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchQuestionData({ questionId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
